<template>
	<sf-data-table
		ref="partTable"
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		paging
		:columns="columns"
		:rows="partList"
		:stripe="false"
		:selection="false"
		@changedPage="changedPage"
		height="520px"
		fit="fit"
	>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					// 품번
					label: this.getMessage_('QWCC000956'),
					prop: 'partNo',
					minWidth: '150px',
					clickEvent: this.scrNameClick,
					highlight: true
				},
				{
					// 품명
					label: this.getMessage_('QWCC000957'),
					prop: 'koPartNm',
					minWidth: '150px'
				},
				{
					// 영문명
					label: this.getMessage_('MWCC000006'),
					prop: 'enPartNm',
					minWidth: '150px'
				},
				{
					// 중문품명
					label: this.getMessage_('QWCC000966'),
					prop: 'chPartNm',
					minWidth: '150px'
				},
				{
					// 부품그룹
					label: this.getMessage_('QWCC000981'),
					prop: 'partGCd',
					minWidth: '1px'
				},
				{
					// 부품그룹
					label: this.getMessage_('QWCC000981'),
					prop: 'partGNm',
					minWidth: '100px'
				},
				{
					// 기본단위
					label: this.getMessage_('QWCC000968'),
					prop: 'bascUtm',
					minWidth: '1px',
					sortable: false
				},
				{
					// 기본단위
					label: this.getMessage_('QWCC000968'),
					prop: 'bascUtmNm',
					minWidth: '100px',
					sortable: false
				},
				{
					// 협력사명
					label: this.getMessage_('QWCC000958'),
					prop: 'cofNm',
					minWidth: '100px',
					sortable: false
				},
				{
					// 사용여부
					label: this.getMessage_('MWCC000891'),
					prop: 'useYnNm',
					minWidth: '80px'
				},
				{
					// 사용여부
					label: this.getMessage_('MWCC000891'),
					prop: 'useYn',
					minWidth: '1px'
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('reload');
		},
		scrNameClick(row) {
			//this.editRow = row;
			this.$emit('SendData', row);
		}
	}
};
</script>

<style></style>
